// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__1Llwd","subheader":"ReorderModal_subheader__KSsRw","listWrap":"ReorderModal_listWrap__38kDj"};